/**
 * Whether a birth year corresponds to an adult (18–100) for the current calendar year.
 * Used by contact and NPS age gates (client + server).
 */
export function isAdultBirthYear(birthYear: string | number): boolean {
  const year = typeof birthYear === "number" ? birthYear : Number.parseInt(birthYear, 10);
  if (!Number.isFinite(year) || !Number.isInteger(year)) return false;

  const currentYear = new Date().getFullYear();
  const age = currentYear - year;
  return age >= 18 && age <= 100;
}

/**
 * Birth-year options for age-check selects (current year down to 100 years ago).
 * Includes under-18 years so the gate can soft-reject kids.
 */
export function getBirthYearOptions(now = new Date()): number[] {
  const currentYear = now.getFullYear();
  const oldest = currentYear - 100;
  const years: number[] = [];
  for (let y = currentYear; y >= oldest; y--) {
    years.push(y);
  }
  return years;
}
